import messages from './messages.tsx';

export const getIssueLimitMessages = (routeName: string) => {
	switch (routeName) {
		case 'rapidboard-board':
		case 'rapidboard-user-board':
		case 'software-boards':
		case 'servicedesk-boards':
			return {
				headerMessage: messages.boardHeader,
				descriptionMessage: messages.boardDescription,
			};

		case 'software-timeline':
		case 'software-timeline-classic':
			return {
				headerMessage: messages.timelineHeader,
				descriptionMessage: messages.timelineDescription,
			};
		case 'rapidboard-backlog':
		case 'rapidboard-user-backlog':
		case 'software-backlog':
		default:
			return {
				headerMessage: messages.backlogHeader,
				descriptionMessage: messages.backlogDescription,
			};
	}
};
